import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

export type StrMap<TValue> = { [key: string]: TValue | TValue[] };

const defaultOptions = {
  responseType: 'json'
};

function getOptions(params?: StrMap<string>, additionalOptions?: any): any {
  return {
    ...defaultOptions,
    ...additionalOptions,
    params
  };
}

export class CrudHttpService {
  private httpClient = inject(HttpClient);

  get<TResponse>({ url, params, additionalOptions }: { url: string; params?: StrMap<string>; additionalOptions?: any }) {
    return this.httpClient.get<TResponse>(url, getOptions(params, additionalOptions));
  }

  post<TResponse, TData = any>({
    url,
    params,
    data,
    additionalOptions
  }: {
    url: string;
    data?: TData;
    additionalOptions?: any;
    params?: StrMap<string>;
  }) {
    return this.httpClient.post<TResponse>(url, data, getOptions(params, additionalOptions));
  }

  put<TResponse, TData = any>({
    url,
    params,
    data,
    additionalOptions
  }: {
    url: string;
    data?: TData;
    additionalOptions?: any;
    params?: StrMap<string>;
  }) {
    return this.httpClient.put<TResponse>(url, data, getOptions(params, additionalOptions));
  }

  delete({ url, params }: { url: string; params?: StrMap<string> }) {
    return this.httpClient.delete(url, getOptions(params));
  }

  deleteMany({ url, params, body }: { url: string; params?: StrMap<string>; body?: any }) {
    const options = getOptions(params);

    if (body) {
      options['body'] = body;
    }
    return this.httpClient.request('delete', url, options);
  }
}
